import { FormBuilder, FormGroup } from '@angular/forms';
import { CodeDescriptionModel } from './code-description.model';

export class Document {
    documentType: CodeDescriptionModel = null;
    otherDocumentType: string = null;
    documentDescription: string = null;
    fileName: string = null;
    documentId: string = null;
    sectionName: string = null;
    constructor(model?: Partial<Document>) {
        if (model && model !== undefined) {
          const def = new Document();
          Object.keys(def).forEach((key: string) => {
            this[key] = model[key] && model[key] !== undefined ?
              model[key] : def[key];
          });
        }
    }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            documentType: [],
            otherDocumentType: [],
            documentDescription: [],
            fileName: [],
            documentId: [],
            sectionName: []
        });
    }

    static generateForm(fb: FormBuilder, model: Document): FormGroup {
        const form = Document.asForm(fb);
        form.setValue(model);
        return form;
    }

    static convertFormToModel(form: FormGroup): Document {
        return form.value;
    }
}
